// Interruptores de sistemas no site. false = escondido (o código e os textos continuam no projeto; para religar, troque para true).
export const SITE_FEATURES = {
  legendPath: false, // Caminho das Lendas: desligado até a progressão do jogo estar pronta
};
